import React, { useLayoutEffect, useMemo } from "react";
import { useControl, ControlPosition } from "react-map-gl/maplibre";
import { createPortal } from "react-dom";

type MapControlProps = {
  position: ControlPosition;
  children: React.ReactNode;
  className?: string;
};

export default function MapControl({
  position = "bottom-left",
  className = "",
  children,
}: MapControlProps): React.ReactNode {
  const control = useMemo(() => document.createElement("div"), []);

  useLayoutEffect(() => {
    control.className = className || "";
  }, [className]);

  useControl(
    () => ({
      onAdd() {
        return control;
      },
      onRemove() {
        control.remove();
      },
      getDefaultPosition() {
        return "bottom-left";
      },
    }),
    { position },
  );
  return createPortal(children, control);
}
